(() => {
  const mobile = window.matchMedia('(max-width: 640px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-cl-pg-laser-reviews]').forEach((track) => {
    const cards = Array.from(track.children);
    if (cards.length < 2 || reducedMotion.matches) return;

    let activeIndex = 0;
    let visible = true;

    const scrollToCard = (index) => {
      const card = cards[index];
      if (!card) return;
      const left = card.offsetLeft - (track.clientWidth - card.clientWidth) / 2;
      track.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    };

    const shouldRotate = () =>
      mobile.matches && visible && !track.matches(':hover') && !track.contains(document.activeElement);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          visible = entries.some((entry) => entry.isIntersecting);
        },
        { root: null, threshold: 0.15 }
      );
      observer.observe(track);
    }

    window.setInterval(() => {
      if (!shouldRotate()) return;

      activeIndex = (activeIndex + 1) % cards.length;
      scrollToCard(activeIndex);
    }, 5000);
  });
})();
